<template>
  <div class="bbe-folder-delete">
    <p>
      Are you sure you want to remove
      <span class="bbe-folder-delete__folder-name">{{target.name}}</span>
      from {{type}}?
    </p>
    <p>
      The restoration of the template will not be possible.
    </p>
  </div>
</template>

<script>
import {get} from 'lodash'

export default {
  name: 'DeleteFolderForm',
  props: ['target'],
  computed: {
    isFolder () {
      return get(this.target, '$info.isFolder', false)
    },
    type () {
      return this.isFolder ? 'Folders' : 'Templates'
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../sass/variables";
@import "../../../../sass/mixins";

.bbe-folder-delete {
  text-align: center;
  font-size: 14px;
  line-height: 17px;
  margin: 33px 18px 41px;

  &__folder-name {
    color: $color-accent;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Templates/TemplatesSidebar/FolderForm/DeleteFolderForm.vue